import React, { useState, useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import "animate.css/animate.min.css";
import { WOW } from "wowjs";

//Custom Components
import HomeTwo from "../pages/home-2";
import AboutMe from "../pages/about/about-me";
import ProjectOne from "../pages/project/project-1";
import ProjectDetails from "../pages/project/project-details";
import Contact from "../pages/contact";
import Error from "../pages/error";

import Preloader from "../components/Preloader";
import ScrollToTop from "../components/ScrollTop";
import LoadTop from "../components/ScrollTop/LoadTop";

const App = () => {
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    // Simulate data loading delay
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  }, []);

  // Initialize wowjs and animate.css
  useEffect(() => {
    new WOW({ live: false, animateClass: "animate__animated" }).init();
  }, [location]);

  return (
    <div className="App">
      {isLoading ? <Preloader /> : ""}
      <>
        <ScrollToTop />
        <LoadTop />
        <Routes>
          <Route path="/" exact element={<HomeTwo />} />
          <Route path="/home" element={<HomeTwo />} />
          <Route path="/about" element={<AboutMe />} />
          <Route path="/projects" element={<ProjectOne />} />
          <Route
            path="/project-details/:projectId"
            element={<ProjectDetails />}
          />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<Error />} />
        </Routes>
      </>
    </div>
  );
};

export default App;
